import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VProgressLinear,_vm._b({attrs:{"value":_vm.progress}},'v-progress-linear',_vm.$attrs,false),[(_vm.showText)?_c('span',[_vm._v(_vm._s(_vm._f("number")(_vm.current / 1000,'0.0')))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }